import React from 'react';
import { Router, Switch } from 'react-router-dom';
import { AdventureWizard, ConfirmEmailWizard, PaymentMethodWizard, PublicProfileWizard, RequestWizard, ReserveWizard } from '../components/FirstStepsWizards';

// layout HOC
import withLayout from '../components/Layout';
import { SessionValidator } from '../components/SessionValidator';
import { allFlattenRoutes as routes, history } from './index';


const Routes = () => (
    // rendering the router with layout
    <Router history={history}>
        <AdventureWizard />
        <ConfirmEmailWizard />
        <PaymentMethodWizard />
        <PublicProfileWizard />
        <RequestWizard />
        <ReserveWizard />
        <SessionValidator />
        <Switch>
            {routes.map((route, index) => {
                return (
                    !route.children && (
                        <route.route
                            key={index}
                            path={route.path}
                            roles={route.roles}
                            exact={route.exact}
                            component={withLayout(props => {
                                return <route.component {...props} />;
                            })}></route.route>
                    )
                );
            })}
        </Switch>
    </Router>
);

export default Routes;
